<template>
  <main>
    <div class="wrap-content">
      <div class="content">
        <div>
          <span>Basic/Annually</span>
          <payment-action plan-id="plan_GWPYFWnxhkBAEk"/>
        </div>
        <div>
          <span>Basic/Monthly</span>
          <payment-action plan-id="plan_GWPXAbEVKotebY"/>
        </div>
        <payment-new v-if="planId" :plan-id="planId"/>
      </div>
    </div>
  </main>
</template>

<script>
import PaymentNew from '../elements/Payments/PaymentNew'
import PaymentAction from '../elements/Payments/PaymentAction'

export default {
  name: 'Payments',
  components: { PaymentNew, PaymentAction },

  computed: {
    planId () {
      return this.$route.params.planId
    }
  }
}
</script>
